import lodash from 'lodash';

import type {
  CssVarsObject,
  RicosCustomStyles,
  RicosNativeStyles,
  RicosSettingsStyles,
} from './../../../ricos-types';

type NestedObject = {
  [key: string]: any;
};

/**
 * Sets `lineHeight` to `1.5` when `fontSize` is provided without `lineHeight`.
 * @param param0 CustomTextualStyle element
 */
export function fixLineHeight(obj: NestedObject): NestedObject {
  return {
    ...lodash.mapValues(obj, value => {
      return typeof value === 'object' && value !== null ? fixLineHeight(value) : value;
    }),
    ...(obj.fontSize !== undefined && obj.lineHeight === undefined ? { lineHeight: 1.5 } : {}),
  };
}

function toVars(
  customStyles: RicosCustomStyles | RicosSettingsStyles | RicosNativeStyles,
  prefix = '',
  separator = '-'
): { [propertyName: string]: string } {
  const propertyNames: { [key: string]: string } = {};

  function traverseObject(currentObj: NestedObject, currentPath = '') {
    for (const [key, value] of Object.entries(currentObj)) {
      const fullPath = currentPath ? `${currentPath}${separator}${key}` : key;
      if (typeof value === 'object') {
        traverseObject(value, fullPath);
      } else {
        propertyNames[`${prefix ? prefix + '-' : ''}${fullPath}`] = value;
      }
    }
  }
  traverseObject(customStyles);

  return propertyNames;
}

type CreateCustomStyles = (param: {
  customStyles?: RicosCustomStyles;
  settingsStyles?: RicosSettingsStyles;
  nativeStyle?: RicosNativeStyles;
}) => CssVarsObject;

const createCustomStyles: CreateCustomStyles = ({
  customStyles = {},
  settingsStyles = {},
  nativeStyle = {},
}) => {
  return lodash.merge(
    {},
    toVars(fixLineHeight(customStyles), 'custom'),
    toVars(settingsStyles, 'settings'),
    toVars(nativeStyle, 'native')
  );
};

export default createCustomStyles;
